import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import Cards from 'react-credit-cards'
import CardFail from 'components/CardFail'
import OrderDetail from 'components/OrderDetail'
import ReactGA from 'react-ga'
import { initFingerPrint, getFingerPrint } from 'components/FingerPrint'
import { connect } from 'react-redux'
import { withRouter, Link, Redirect } from 'react-router-dom'
import { payWithCard, allowClickToPay } from 'actions'
import 'react-credit-cards/es/styles-compiled.css'
import 'static/css/CardPayment.css'
import {
  InputCreditCardDate,
  InputCvv,
  InputName,
  InputCPF,
  InputCNPJ,
  Button,
  ButtonGroup,
  Well,
  Checkbox,
} from '@yapay/design-system'
import InputCreditCard from 'components/InputCreditCard'
import Recaptcha from 'components/Recaptcha'
import RedirectWithTimer from './RedirectWithTimer'
import SplitSelect from 'components/SplitSelect'

const initialState = {
  number: '',
  name: 'Seu nome',
  expiry: '',
  cvc: '',
  focused: '',
  issuer: '',
  btnText: 'Pagar',
  payment_method: 'mastercard',
  tokenRecaptcha: '',
  dirtyPayButton: false,
  split_number: '',
  disabledSplitNumber: false,
  isCNPJ: false,
  document: '',
  documentValid: null,
  documentError: '',
  checkingDocument: false,
}

export class CardPayment extends Component {
  state = initialState

  handleInputFocus = ({ target }) => {
    this.setState({ focused: target.name })
  }

  handleBlurCard = value => {
    if (value !== 'none') {
      this.setState({ payment_method: value }, () => this.checkSplitNumber())
    }
  }

  handleClickCard = value => {
    this.setState(
      {
        payment_method: value,
        issuer: value,
      },
      () => this.checkSplitNumber(),
    )
  }

  handleBlurCVV = () => {
    this.setState({ focused: 'name' })
  }

  handleCardNumber = ({ target }) => {
    this.setState({
      number: target.value.replace(/ /g, ''),
      card_number: target.value.replace(/ /g, ''),
    })
    // Call prop callback if provided (for SRC wrapper)
    if (this.props.onCardNumberChange) {
      this.props.onCardNumberChange(target.value.replace(/ /g, ''))
    }
  }

  handleExpiry = ({ target }) => {
    this.setState({
      expiry: target.value,
      card_expiration_month: target.value.split('/')[0],
      card_expiration_year: '20' + target.value.split('/')[1],
    })
  }

  handleName = ({ target }) => {
    this.setState({
      name: target.value,
      card_name: target.value,
    })
  }

  handleCVV = ({ target }) => {
    this.setState({ cvc: target.value, card_cvv: target.value })
  }

  handleSelect = ({ target }) => {
    if (
      this.props.split_number !== undefined &&
      this.props.onSplitNumberChange
    ) {
      this.props.onSplitNumberChange(target.value)
    } else {
      this.setState({
        split_number: target.value,
      })
    }
  }

  handleDocumentBlur = () => {
    if (this.state.document) {
      return this.validateDocument()
    }

    this.setState({
      document: '',
      documentValid: true,
      documentError: '',
      checkingDocument: false,
    })
  }

  handleDocumentChange = ({ target }) => {
    const value = target.value

    if (!value || value.trim() === '') {
      this.setState({
        document: '',
        documentValid: true,
        documentError: '',
        checkingDocument: false,
      })
      return
    }

    this.setState(
      {
        document: value,
        documentValid: false,
        documentError: 'Documento inválido',
        checkingDocument: false,
      },
      () => {
        const numericValue = value.replace(/\D/g, '')
        const isValidLength = this.state.isCNPJ
          ? numericValue.length === 14
          : numericValue.length === 11

        if (isValidLength) {
          this.validateDocument()
        }
      },
    )
  }

  validateDocument = () => {
    const { document } = this.state

    if (!document || document.trim() === '') {
      this.setState({
        document: '',
        documentValid: true,
        documentError: '',
        checkingDocument: false,
      })
      return Promise.resolve()
    }

    this.setState({ checkingDocument: true })

    const cleanDocument = document.replace(/\D/g, '')

    if (!cleanDocument) {
      this.setState({
        documentValid: true,
        documentError: '',
        checkingDocument: false,
      })
      return Promise.resolve()
    }

    const isValidLength = this.state.isCNPJ
      ? cleanDocument.length === 14
      : cleanDocument.length === 11

    this.setState({
      documentValid: isValidLength,
      documentError: isValidLength ? '' : 'Documento inválido',
      checkingDocument: false,
    })

    return Promise.resolve()
  }

  toggleDocumentType = event => {
    const isCNPJ = event.target.checked
    this.setState({
      isCNPJ,
      document: '',
      documentValid: null,
      documentError: '',
    })
  }

  storeCardWithSrcConsentIfNeeded = async () => {
    if (
      !this.props.onStoreCardWithSrcConsent ||
      !this.props.srcConsentAccepted
    ) {
      return null
    }

    const args = {
      card_number: this.state.card_number,
      card_expiration_month: this.state.card_expiration_month,
      card_expiration_year: this.state.card_expiration_year,
      card_cvv: this.state.card_cvv,
    }

    await this.props.onStoreCardWithSrcConsent(args)
  }

  submitForm = event => {
    this.setState({ dirtyPayButton: true })
    if (event?.preventDefault) {
      event.preventDefault()
    }

    if (
      (this.state.document && !this.state.documentValid) ||
      !this.state.tokenRecaptcha
    ) {
      return
    }

    const data = {
      card_cvv: this.state.card_cvv || '',
      card_expiration_month: this.state.card_expiration_month || '',
      card_expiration_year: this.state.card_expiration_year || '',
      card_name: this.state.card_name || '',
      card_number: this.state.card_number || '',
      split_number: this.props.split_number || this.state.split_number,
      payment_method: this.state.payment_method || '',
      card_holder_doc: this.state.document
        ? this.state.document.replace(/\D/g, '')
        : '',
      // from props
      token: this.props.token,
      seller_token: this.props.sellerToken,
      address_token: this.props.addressToken,
      order_token: this.props.orderToken,
      transaction_token: this.props.transactionToken,
      payment_retry: this.props.paymentRetry,
      email: this.props.email,
      finger_print: getFingerPrint(),
      token_recaptcha: this.state.tokenRecaptcha,
    }
    if (this.props.transaction && this.props.transaction.type === 't') {
      data.customer = this.props.customer
    }

    return this.handlePay(data)
  }

  shouldPayWithCheckoutCard = () => {
    return (
      this.props.makeCheckoutWithCard &&
      this.props.srcSavedCards &&
      this.props.srcSavedCards.length > 0 &&
      !this.props.manualEntrySelected
    )
  }

  handlePay = async data => {
    if (!this.shouldPayWithCheckoutCard()) {
      if (
        data.card_number === '' &&
        data.card_name === '' &&
        data.card_expiration_month === '' &&
        data.card_expiration_year === '' &&
        data.payment_method.length === 0
      ) {
        return null
      }
    }

    this.setState({ btnText: 'Processando...' })

    if (allowClickToPay(this.props.seller)) {
      let storeCardResult = null

      if (this.shouldPayWithCheckoutCard()) {
        storeCardResult = await this.props.makeCheckoutWithCard()
      } else {
        storeCardResult = await this.storeCardWithSrcConsentIfNeeded()
      }

      const wallet_data = this.processCheckoutResponse(storeCardResult)

      if (wallet_data) {
        data.wallet = wallet_data
      }
    }

    const resp = await this.props.dispatch(payWithCard(data))

    this.setState({ btnText: 'Pagar' })

    this.processApiResponse(resp)

    return resp
  }

  processCheckoutResponse = storeCardResult => {
    if (!storeCardResult) {
      return null
    }

    const status = storeCardResult.checkoutActionCode

    if (status === 'COMPLETE') {
      const correlationId =
        storeCardResult.checkoutResponseData.srcCorrelationId
      const merchantId = storeCardResult.headers['merchant-transaction-id']
      const flowId = storeCardResult.headers['x-src-cx-flow-id']

      const wallet_data = {
        kind: 'click_to_pay',
        origin: 'checkout_vindi',
        external_correlation_id: correlationId,
        src_dpa_id: process.env.REACT_APP_MASTERCARD_SRC_DPA_ID,
        merchant_transaction_id: merchantId,
        src_cx_flow_id: flowId,
      }

      this.setState({
        responseCardData: storeCardResult.checkoutResponseData.maskedCard,
      })

      return wallet_data
    }

    return null
  }

  processApiResponse = resp => {
    if (resp === null) {
      ReactGA.event({
        category: 'Card Payment',
        action: 'Failed to process',
      })

      if (this.props.onPaymentDenied) {
        this.props.onPaymentDenied(false)
      }

      this.setState({ showMessageError: true })
      return null
    }

    if (resp.data.status === 'denied') {
      ReactGA.event({
        category: 'Card Payment',
        action: 'Payment Denied',
      })

      if (this.props.onPaymentDenied) {
        this.props.onPaymentDenied()
      }

      this.setState({
        ...initialState,
        ...resp.data,
        denied: true,
      })

      return false
    }

    this.props.history.replace(`/pagamento/${resp.data.transaction_token}`, {
      responseCardData: this.state.responseCardData || {},
    })

    return true
  }

  tryAgain = () => {
    ReactGA.event({
      category: 'Card Payment',
      action: 'Try to pay again',
    })
    this.setState({ denied: false, showMessageError: false })

    if (this.props.onTryAgain) {
      this.props.onTryAgain()
    }
  }

  checkSplitNumber = () => {
    if (!this.props.availableMethods) {
      return
    }

    const paymentMethod = this.props.availableMethods.find(
      ({ name }) => name === this.state.payment_method,
    )
    const hasOnlyOneSplitOption =
      paymentMethod && paymentMethod.split.length === 1
    const splitNumber = hasOnlyOneSplitOption ? '1' : ''

    this.setState({
      split_number: splitNumber,
      disabledSplitNumber: !!paymentMethod && hasOnlyOneSplitOption,
    })
  }

  renderCrediCard = () => {
    const { name, number, expiry, cvc, focused, issuer } = this.state
    return (
      <MediaQuery query="(min-width: 768px)">
        <div className="ml-8">
          <Cards
            number={number}
            name={name}
            expiry={expiry}
            cvc={cvc}
            focused={focused}
            issuer={issuer}
            preview={true}
          />
        </div>
      </MediaQuery>
    )
  }

  renderCardFail = () => {
    const { billetAvailable, transaction, message } = this.props

    return (
      <CardFail
        transaction={transaction}
        message={message}
        billetAvailable={billetAvailable}
        tryAgain={this.tryAgain}
      />
    )
  }

  componentDidMount() {
    initFingerPrint()
    this.checkSplitNumber()
  }

  render() {
    ReactGA.event({
      category: 'Choose Payment',
      action: 'Card',
    })

    if (this.props.orderUndefined) {
      return <Redirect to="/nao-encontrado" />
    }

    if (this.state.denied) {
      return this.renderCardFail()
    }

    let showFormFields =
      this.props.manualEntrySelected === true ||
      !this.props.srcSavedCards ||
      this.props.srcSavedCards.length === 0 ||
      this.props.showSrcCardList === false

    if (
      this.props.srcLoading &&
      this.props.manualEntrySelected !== true &&
      this.props.showSrcCardList !== false
    ) {
      showFormFields = false
    }

    return (
      <form
        onSubmit={this.submitForm}
        id="payment-form"
        data-yapay="payment-form"
      >
        {showFormFields && (
          <>
            <h2>Preencha os campos com os dados do cartão</h2>
            <div className="flex">
              <div className="flex-1">
                <InputCreditCard
                  label="Número do Cartão"
                  id="cardNumber"
                  name="number"
                  onFocus={this.handleInputFocus}
                  onChange={this.handleCardNumber}
                  onBlur={this.handleBlurCard}
                  onClick={this.handleClickCard}
                  availableCC={this.props.cardFlags}
                  clickToPayIcons={allowClickToPay(this.props.seller)}
                  required
                />
                <InputName
                  label="Nome do titular"
                  id="card-name"
                  name="name"
                  type="text"
                  autoComplete="off"
                  onFocus={this.handleInputFocus}
                  onChange={this.handleName}
                  maxLength={30}
                  required
                />

                <div className="mb-4">
                  <Checkbox
                    label="Pessoa Jurídica?"
                    onChange={this.toggleDocumentType}
                    checked={this.state.isCNPJ}
                  />
                </div>

                {this.state.isCNPJ ? (
                  <div className="relative">
                    <InputCNPJ
                      label="CNPJ do titular do cartão"
                      name="document"
                      id="document"
                      value={this.state.document}
                      valid={this.state.documentValid}
                      errorMessage={this.state.documentError}
                      onChange={this.handleDocumentChange}
                      onBlur={this.handleDocumentBlur}
                    />
                    {this.state.checkingDocument && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="35"
                        height="35"
                        viewBox="0 0 50 50"
                        fill="#e1e1e1"
                        className="absolute top-0"
                        style={{ top: '13px', right: '1rem' }}
                      >
                        <path d="M43.94 25.14a18.68 18.68 0 1 0-37.37 0h4.07a14.62 14.62 0 0 1 29.23 0h4.07z">
                          <animateTransform
                            attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="0.4s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                    )}
                  </div>
                ) : (
                  <div className="relative">
                    <InputCPF
                      label="CPF do titular do cartão"
                      name="document"
                      id="document"
                      value={this.state.document}
                      valid={this.state.documentValid}
                      errorMessage={this.state.documentError}
                      onChange={this.handleDocumentChange}
                      onBlur={this.handleDocumentBlur}
                    />
                    {this.state.checkingDocument && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="35"
                        height="35"
                        viewBox="0 0 50 50"
                        fill="#e1e1e1"
                        className="absolute top-0"
                        style={{ top: '13px', right: '1rem' }}
                      >
                        <path d="M43.94 25.14a18.68 18.68 0 1 0-37.37 0h4.07a14.62 14.62 0 0 1 29.23 0h4.07z">
                          <animateTransform
                            attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="0.4s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                    )}
                  </div>
                )}

                <InputCreditCardDate
                  label="Data de vencimento"
                  id="card-date"
                  name="expiry"
                  onFocus={this.handleInputFocus}
                  onChange={this.handleExpiry}
                  required
                />
                <InputCvv
                  label="Código CVV"
                  id="card-cvv"
                  name="cvc"
                  onFocus={this.handleInputFocus}
                  onChange={this.handleCVV}
                  onBlur={this.handleBlurCVV}
                  required
                />
                <SplitSelect
                  availableMethods={this.props.availableMethods}
                  totalPrice={this.props.totalPrice}
                  paymentMethod={this.state.payment_method}
                  value={
                    this.props.split_number !== undefined
                      ? this.props.split_number
                      : this.state.split_number
                  }
                  onChange={this.handleSelect}
                  disabled={this.state.disabledSplitNumber}
                  id="payment-option"
                />
              </div>
              {this.renderCrediCard()}
            </div>

            <MediaQuery query="(max-width: 767px)">
              <Well className="p-4 md:p-4 -mx-4" plain>
                <OrderDetail />
              </Well>
            </MediaQuery>

            <div className="mb-4">
              <Recaptcha
                onChange={tokenRecaptcha => this.setState({ tokenRecaptcha })}
                invalid={
                  !this.state.tokenRecaptcha && this.state.dirtyPayButton
                }
                errorMessage="Confirme o reCAPTCHA para continuar"
              />
            </div>

            {this.state.showMessageError && (
              <p className="text-red-400 text-center">
                Não foi possível realizar o pagamento
              </p>
            )}

            {this.state.showMessageError && this.props.redirectUrl && (
              <RedirectWithTimer
                className="text-center -mt-4"
                to={this.props.redirectUrl}
              />
            )}
          </>
        )}

        {!showFormFields && (
          <>
            <div className="mb-4">
              <Recaptcha
                onChange={tokenRecaptcha => this.setState({ tokenRecaptcha })}
                invalid={
                  !this.state.tokenRecaptcha && this.state.dirtyPayButton
                }
                errorMessage="Confirme o reCAPTCHA para continuar"
              />
            </div>

            {this.state.showMessageError && (
              <p className="text-red-400 text-center">
                Não foi possível realizar o pagamento
              </p>
            )}

            {this.state.showMessageError && this.props.redirectUrl && (
              <RedirectWithTimer
                className="text-center -mt-4"
                to={this.props.redirectUrl}
              />
            )}
          </>
        )}

        {this.props.srcConsentElement && (
          <div className="mb-4">{this.props.srcConsentElement}</div>
        )}

        <ButtonGroup responsive className="items-center">
          <Link to="/escolha-pagamento" className="button text-center">
            Voltar
          </Link>
          <Button className="sm:w-64" color="info">
            {this.state.btnText}
          </Button>
        </ButtonGroup>
      </form>
    )
  }
}

CardPayment.propTypes = {
  transaction: PropTypes.object,
  history: PropTypes.object,
  dispatch: PropTypes.func,
  redirectUrl: PropTypes.string,
  customer: PropTypes.object,
  srcSavedCards: PropTypes.array,
  manualEntrySelected: PropTypes.bool,
  srcConsentAccepted: PropTypes.bool,
  onCardNumberChange: PropTypes.func,
  onStoreCardWithSrcConsent: PropTypes.func,
  makeCheckoutWithCard: PropTypes.func,
  onPaymentDenied: PropTypes.func,
  showSrcCardList: PropTypes.bool,
  srcConsentElement: PropTypes.node,
  srcLoading: PropTypes.bool,
  onTryAgain: PropTypes.func,
  split_number: PropTypes.string,
  onSplitNumberChange: PropTypes.func,
}

const mapStateToProps = /* istanbul ignore next */ state => {
  const {
    user: { address_token: addressToken, email },
    transaction: {
      paymentRetry,
      orderUndefined,
      order: {
        message,
        token,
        available_payment_methods: paymentMethods,
        total_price: totalPrice,
        max_split_transaction: maxSplit,
        order_token: orderToken,
        transaction_token: transactionToken,
        url_cancel,
        url_process,
      },
      seller,
    },
  } = state
  const sellerToken = seller.token
  let availableMethods = null
  let cardFlags = null
  const transaction = state.transaction
  const billetAvailable = paymentMethods.some(item => item.type === 'billet')

  if (paymentMethods.length) {
    availableMethods = paymentMethods.filter(item => item.type === 'card')
    availableMethods = availableMethods[0].values
    cardFlags = availableMethods.map(({ name }) => name)
  }

  const redirectUrl = url_cancel || url_process || null
  const customer = {
    name: state.user.name,
    company_name: state.user.company_name,
    email: state.user.email,
    cpf: state.user.cpf,
    cnpj: state.user.cnpj,
    zip_code: state.user.zip_code,
    street: state.user.street,
    number: state.user.number,
    neighborhood: state.user.neighborhood,
    city: state.user.city,
    state: state.user.state,
    phone: state.user.phone,
  }

  return {
    token,
    orderToken,
    transactionToken,
    redirectUrl,
    availableMethods,
    cardFlags,
    totalPrice,
    orderUndefined,
    transaction,
    message,
    maxSplit,
    sellerToken,
    addressToken,
    paymentRetry,
    email,
    billetAvailable,
    customer,
    seller,
  }
}

export default withRouter(connect(mapStateToProps)(CardPayment))
